import styled from 'styled-components';

const MemberCard = ({ className, member }) => {
  return (
    <S.Card className={className}>
      <S.Avatar src={member.image} alt={member.firstName} />
      <S.Name>{`${member.firstName} ${member.lastName}`}</S.Name>
      <S.Position>{member.position}</S.Position>
      <S.Email>{member.email}</S.Email>
    </S.Card>
  );
};

const S = {
  Card: styled.div`
    background: #fff;
    width: 100%;
    padding: 2.5rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 18px;
    color: ${({ theme }) => theme.colors.bodyText};
  `,
  Avatar: styled.img`
    border-radius: 50%;
    width: 110px;
  `,
  Name: styled.h3`
    margin: 1.5rem 0 0.5rem 0;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: -0.1px;
  `,
  Position: styled.span`
    opacity: 0.6;
    font-size: 0.9rem;
  `,
  Email: styled.span`
    opacity: 0.6;
    font-size: 0.8rem;
    margin-top: 0.75rem;
  `,
};

export default MemberCard;
